<div>
    @for (payment of paymentHistory.salePayments; let i = $index; track payment.id) {
        <div
            [class.tw:border-b]="!payment?.tip" class="tw:flex tw:items-center tw:justify-between tw:border-b-neutral-200 tw:py-2 tw:text-sm tw:font-semibold tw:last:mb-0 tw:last:border-0"
        >
            <div>
                <div>{{ 'GENERAL.paid' | translate }} ({{ payment.paidAt | date: 'short' }})</div>
                <div>{{ payment.paymentMethod | paymentMethod:payment.isOnlinePayment }}</div>
            </div>

            <div class="tw:text-success-800">+{{ payment.amount | merchantCurrency }}</div>
        </div>
        @if (payment?.tip) {
            <div
                class="tw:-mt-4 tw:flex tw:items-center tw:justify-between tw:border-b tw:border-b-neutral-200 tw:py-2 tw:text-xs tw:font-semibold tw:last:mb-0 tw:last:border-0"
            >
                <div>
                    <div>{{ 'SALE_DETAILS.tip' | translate }}</div>
                </div>
    
                <div class="tw:text-success-800">+{{ payment.tip | merchantCurrency }}</div>
            </div>
        }
    }
    @if (paymentHistory.status === ISaleStatus.PENDING_PAYMENT) {
        <div class="tw:flex tw:items-center tw:justify-between tw:py-2 tw:text-sm tw:font-semibold">
            <div>{{ 'SALE_DETAILS.missingPayment' | translate }}</div>
            <div class="tw:text-error-800">
                {{ (paymentHistory.totalCents - paymentHistory.paidAmountCents) / 100 | merchantCurrency }}
            </div>
        </div>
    }
    @for (creditNote of paymentHistory.creditNotes; let i = $index; track creditNote.id) {
        @if (creditNote.showInPaymentsHistory) {
            <div
                class="tw:flex tw:items-center tw:justify-between tw:border-b tw:border-b-neutral-200 tw:py-2 tw:text-sm tw:font-semibold tw:text-error-800 tw:last:mb-0 tw:last:border-0"
            >
                <div>
                    <div>{{ 'SALE_DETAILS.canceled' | translate }}</div>
                    <div>{{ creditNote.createdAt | date: 'short' }}</div>
                </div>
                <div>
                    {{ creditNote.amount | merchantCurrency }}
                </div>
            </div>
        }
    }
</div>
